class QbIconBase extends HTMLElement {
    constructor() {
        super();
        const template = document.createElement("template");
        const varName = "--" + this.nodeName.toLowerCase().replace(/^i-/, "icon-");
        template.innerHTML = `<style>
        :host { display: contents; } 
        span { 
            /*height: var(--i-icon-size); */
            margin: var(--i-icon-margin);
            font-size: var(--i-icon-font-size, calc(0.8 * var(--i-icon-size, inherit)));
            letter-spacing: var(--i-icon-letter-spacing);
            line-height:var(--i-icon-size, 1em);
            place-items:center;
            aspect-ratio:1;
            display: inline-grid; 
            grid-template-columns: var(--i-icon-size, 100%);
        } 
        span:before { content: var(${varName}); }</style><span part="icon"></span>`;
        this.attachShadow({mode: "open"}).append(template.content);
    }

    connectedCallback() {
        this.classList.add("i-icon");
        if(this.hasAttribute("aria-label")) return;
        this.setAttribute("aria-label", this.nodeName.toLowerCase().replace(/^i-/, ""));
    }
}

class QbIconSVG extends HTMLElement {
    static register(nodeName, svg) {
        const klass = class extends this {};
        klass.template = document.createElement("template");
        klass.template.innerHTML = `<style> 
            :host {
                display: contents;
            }
            svg {
                place-self: center;
                margin: var(--i-icon-margin);
                width: var(--i-icon-size, auto); 
                fill: var(--svg-icon-fill, var(--color-fg, black));
                stroke:  var(--svg-icon-stroke, var(--color-bg, white));
                stroke-width:  var(--svg-icon-stroke-width, 0);
            }
        </style><svg part="icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xml:space="preserve"></svg>`;
        klass.template.content.lastElementChild.innerHTML = svg;
        customElements.define(nodeName, klass);
    }

    constructor() {
        super();
        this.attachShadow({mode: "open"}).append(this.constructor.template.content.cloneNode(true));
    }

    connectedCallback() {
        if(this.hasAttribute("replace")) {
            const node = this.shadowRoot.querySelector("svg");
            if(node) {
                const aria_label = this.getAttribute("aria-label") || this.nodeName.toLowerCase().replace(/^i-/, "");
                node.setAttribute("aria-label", aria_label);
                node.classList.add("i-icon-replacement");
                this.replaceWith(node);
                return;
            }
        }
        this.classList.add("i-icon");
        if(this.hasAttribute("aria-label")) return;
        this.setAttribute("aria-label", this.nodeName.toLowerCase().replace(/^i-/, ""));
    }
}

QbIconSVG.register("i-play", `<polygon points='6.7,0 6.7,100 93.3,50' />`);
// QbIconSVG.register("i-play", `<use href="#Icon-pause"/></svg>`);
QbIconSVG.register("i-stop", `<rect x='6.7' y='6.7' width='86.6' height='86.6' />`);
QbIconSVG.register("i-pause", `<rect x='6.7' y='6.7' width='34.64' height='86.6' /><rect x='58.66' y='6.7' width='34.64' height='86.6' />`);
// QbIconSVG.register("i-translate", `<g transform="translate(-15.5,-15.5)">
// <path d="m 46.4,52.6 c -4.2,-4.1 -7.9,-7.7 -10,-16 H 51.1 V 30.4 H 36.5 v -8.2 h -6.3 v 8.3 H 15.5 v 6.2 h 15 c 0,0 -0.1,1.2 -0.3,2.1 -2.1,8.2 -4.6,13.4 -14.7,18.5 l 2.1,6.2 C 27.2,58.4 32.2,52 34.4,44.9 c 2.1,5.4 5.7,9.8 9.8,13.8 l 2.2,-6.1 z" />
// <path d="M 65.8,32.5 H 57.4 L 42.7,73.8 H 49 L 53.2,61.4 H 70 l 4.2,12.4 h 6.3 L 65.8,32.5 z m -10.5,22.7 6.3,-16.5 6.3,16.6 -12.6,-0.1 0,0 z" />
// </g>`, { viewBox: "0 0 65 65" });



const icon_register = function(nodeName) {
    nodeName = "i-" + nodeName.toLowerCase().replace(/^-*i(?:con)?-/, "");
    if(customElements.get(nodeName)) return nodeName;
    customElements.define(nodeName, class extends QbIconBase {});
    return nodeName;
}

self.QbIcon = function (nodeName, ...args) {
    return cT(icon_register(nodeName), ...args);
}
self.QbIcon.register = () => {
    document.customPropertyNames.forEach(p => /^--icon-/.test(p) && icon_register(p));
}
document.addEventListener("DOMContentLoaded", function() {
    QbIcon.register();
});
